/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import LandingPageLayout from '../components/layouts/LandingPageLayout';
export const meta = {
  author: 'Jens Seip'
};
const MDXLayout = ({children}) => _jsx(LandingPageLayout, {
  customHeader: _jsx("div", {}),
  disableHeadline: true,
  mdx: true,
  meta: meta,
  children: children
});
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      hr: "hr",
      strong: "strong"
    }, props.components);
    return _jsxs(_Fragment, {
      children: [_jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
        children: "Curipod Learning Principles"
      }), "\n", _jsx(_components.p, {
        children: "The Curipod Learning Principles give us direction, and help us always to put the students and their learning experience first as we develop Curipod. They are informed by the learning sciences and serve as our North Star."
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx(_components.hr, {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsxs(_components.p, {
        children: [_jsxs(_components.strong, {
          children: ["We inspire students to be curious and flexible thinkers.", _jsx("sup", {
            children: "1,2"
          })]
        }), " A Curipod activity encourages students to wonder, inquire, and actively search for and create knowledge - critically assessing what they find."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsxs(_components.strong, {
          children: ["We bring the classroom together.", _jsx("sup", {
            children: "3"
          })]
        }), " Every student feels safe to participate, share their opinion, and be curious."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsxs(_components.strong, {
          children: ["We make learning relevant.", _jsx("sup", {
            children: "4"
          })]
        }), " Enabling teachers to personalize lessons, content, and activities with AI based on student's interests and the community around them."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsxs(_components.strong, {
          children: ["We encourage students to learn with and from each other.", _jsx("sup", {
            children: "5"
          })]
        }), " A Curipod activity sparks in-person collaboration, discussion, and students looking up from their screens."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsxs(_components.strong, {
          children: ["We make space for students to have a say in their learning.", _jsx("sup", {
            children: "6"
          })]
        }), " Including what they learn, how they learn, and how they show what they know."]
      }), "\n", _jsxs(_components.p, {
        children: [_jsxs(_components.strong, {
          children: ["We enable frequent, personal feedback for each student.", _jsx("sup", {
            children: "7"
          })]
        }), " We help teachers do this with the assistance of artificial intelligence"]
      }), "\n", _jsxs(_components.p, {
        children: [_jsxs(_components.strong, {
          children: ["We engage all learners.", _jsx("sup", {
            children: "8"
          })]
        }), " All students, including the ones who are usually less engaged, get to shine with Curipod."]
      }), "\n", _jsx("br", {}), "\n", _jsx(_components.hr, {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("p", {
        style: {
          lineHeight: '20px',
          fontSize: '12px',
          fontStyle: 'italic',
          marginBottom: 2
        },
        children: "1. Spector, J. M. (2019). Complexity, inquiry critical thinking, and technology: A holistic and developmental approach. Mind, brain and technology: Learning in the age of emerging technologies, 17-25. "
      }), "\n", _jsx("p", {
        style: {
          lineHeight: '20px',
          fontSize: '12px',
          fontStyle: 'italic',
          marginBottom: 2
        },
        children: "2. Barak, M., & Levenberg, A. (2016). Flexible thinking in learning: An individual differences measure for learning in technology-enhanced environments. Computers & Education, 99, 39-52."
      }), "\n", _jsx("p", {
        style: {
          lineHeight: '20px',
          fontSize: '12px',
          fontStyle: 'italic',
          marginBottom: 2
        },
        children: "3. Darling-Hammond, L., Flook, L., Cook-Harvey, C., Barron, B., & Osher, D. (2020). Implications for educational practice of the science of learning and development. Applied Developmental Science, 24, 97-140."
      }), "\n", _jsx("p", {
        style: {
          lineHeight: '20px',
          fontSize: '12px',
          fontStyle: 'italic',
          marginBottom: 2
        },
        children: "4. Ryan, R. M., & Deci, E. L. (2020). Intrinsic and extrinsic motivation from a self-determination theory perspective: Definitions, theory, practices, and future directions. Contemporary educational psychology, 61, 101860."
      }), "\n", _jsx("p", {
        style: {
          lineHeight: '20px',
          fontSize: '12px',
          fontStyle: 'italic',
          marginBottom: 2
        },
        children: "5. Johnson, D. W., and Johnson, R. T. (2009). An educational psychology success story: social interdependence theory and cooperative learning. Educational Research. 38, 365–379. doi: 10.3102/0013189x09339057"
      }), "\n", _jsx("p", {
        style: {
          lineHeight: '20px',
          fontSize: '12px',
          fontStyle: 'italic',
          marginBottom: 2
        },
        children: "6. Cook-Sather, A. (2020). Student voice across contexts: Fostering student agency in today’s schools. Theory into practice, 59(2), 182-191."
      }), "\n", _jsx("p", {
        style: {
          lineHeight: '20px',
          fontSize: '12px',
          fontStyle: 'italic',
          marginBottom: 2
        },
        children: "7. Hattie, J., & Timperley, H. (2007). The power of feedback. Review of Educational Research, 77(1), 81-112."
      }), "\n", _jsxs("p", {
        style: {
          lineHeight: '20px',
          fontSize: '12px',
          fontStyle: 'italic',
          marginBottom: 2
        },
        children: ["8. Brackett, M. A., Rivers, S. E., Reyes, M. R., & Salovey, P. (2012). Enhancing academic performance and social and emotional competence with the RULER feeling words curriculum. Learning and Individual Differences, 22, 218–224. ", _jsx("a", {
          style: {
            fontSize: '12px'
          },
          href: "https://doi.org/10.1016/j.lindif.2010.10.002",
          children: "https://doi.org/10.1016/j.lindif.2010.10.002"
        })]
      }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsx("br", {})]
    });
  }
}
export default MDXContent;
